import { useMemo } from 'react';

import { type Device } from '../types/deviceEvents.type';
import { devicePublisher } from '../utils/deviceEventsPublisher.util';

export const useDeviceEvents = <D extends Device>(options: { device: D }) => {
  const { device } = options;

  const track = useMemo(() => devicePublisher(device), [device]);

  return { device, track };
};
